import React, { useState, useEffect, useContext } from 'react'
import POHeader from './POHeader'
import POInner from './POInner'
import POFooter from './POFooter'
import { appContext } from '../../../../App'
import { dateYMD } from '../../utilities'
import { getProductsList } from '../../../products/ProductsFunctions'
import { isObjEmpty } from '../../utilities'
import { getPOList, savePO } from '../PurchaseOrderFunctions'

export const poControllerContext = React.createContext()

function usePOController(props) {
  const app = useContext(appContext)

  const initPO = {
    status: 'Unposted',
    date_prepared: dateYMD(new Date(app.getClientDateTime())),
    supplier: '',
    prepared_by: '',
    reference_code: '',
    remarks: '',
    // 0 - Delete after used
    // 1 - Dont delete after used
    access_mode: 0,
    item_details: []
  }

  const initPOItemDetail = {
    id: '',
    name: '',
    unit: '',
    quantity: 1,
    remarks: ''
  }

  const [po, setPO] = useState(null)
  const [poItemDetail, setPOItemDetail] = useState(initPOItemDetail)
  const [poList, setPOList] = useState([])
  const [productsList, setProductsList] = useState([])

  const resetPOItemDetail = () => setPOItemDetail(initPOItemDetail)

  useEffect(() => {
    const init = async () => {
      const po_list = await getPOList(app)
      const products_list = await getProductsList(app)

      setPOList(po_list)

      // Immediate data not state
      const pl = products_list.map(item => (
        {
          item_id: item._id,
          item_units: item.units,
          item_full_description: `${item.brand} ${item.name} ${item.description}`
        }
      ))

      setProductsList(pl)

      // Create new PO
      if (isObjEmpty(props)) {
        const pur_ord = await savePO(app, initPO)
        setPO({
          ...pur_ord,
          init: true,
          date_prepared: dateYMD(new Date(pur_ord.date_prepared))
        })
      } else {
        setPO({
          ...props.poItem,
          init: true,
          date_prepared: dateYMD(new Date(props.poItem.date_prepared))
        })
      }
    }

    init()

    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    const autoSave = async () => {
      if (po.init) return delete po.init 
      // else
      await savePO(app, po, true)
    }

    if (po) autoSave()

    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [po])

  return ({
    po: [po, setPO, savePO],
    poItemDetail: [poItemDetail, setPOItemDetail, resetPOItemDetail],
    poList, productsList
  })
}

function POController(props) {
  const poController = usePOController(props)
  if (poController.po[0])
    return (
      <React.Fragment>
        <poControllerContext.Provider value={poController}>
          <POHeader />
          <POInner />
          <POFooter />
        </poControllerContext.Provider>
      </React.Fragment>
    )
  else return null
}

export default React.memo(POController)